"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiPaymentIntentDto = exports.BillingApiPaymentIntentAbstractDto = void 0;
const swagger_1 = require("../../../../swagger-fake");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
/**
 * Инициализация платежа.
 */
let BillingApiPaymentIntentAbstractDto = class BillingApiPaymentIntentAbstractDto {};
__decorate([(0, swagger_1.ApiProperty)({
  description: "Страна плательщика"
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsString)(), __metadata("design:type", String)], BillingApiPaymentIntentAbstractDto.prototype, "countryCode", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Имя плательщика"
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsString)(), __metadata("design:type", String)], BillingApiPaymentIntentAbstractDto.prototype, "firstName", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Фамилия плательщика"
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsString)(), __metadata("design:type", String)], BillingApiPaymentIntentAbstractDto.prototype, "lastName", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Эл. почта плательщика"
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsEmail)(), __metadata("design:type", String)], BillingApiPaymentIntentAbstractDto.prototype, "email", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Телефон плательщика",
  nullable: true,
  required: false
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsPhoneNumber)(), __metadata("design:type", Object)], BillingApiPaymentIntentAbstractDto.prototype, "phone", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Id платёжного счёта. Если нет, то выбирается счёт последнего успешного платежа по сделке. 
      Иначе возможны варианты (не доступны в текущей версии), например, выполнить оплату новой картой`,
  type: String,
  format: "uuid",
  nullable: true,
  required: false
}), (0, class_validator_1.IsOptional)(), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsUUID)(4), __metadata("design:type", Object)], BillingApiPaymentIntentAbstractDto.prototype, "accountId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Использовать ли для будущих платежей",
  type: Boolean,
  required: false,
  nullable: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsBoolean)(), __metadata("design:type", Object)], BillingApiPaymentIntentAbstractDto.prototype, "featureUsage", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Установить ли как способ оплаты по молчанию",
  type: Boolean,
  required: false,
  nullable: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsBoolean)(), __metadata("design:type", Object)], BillingApiPaymentIntentAbstractDto.prototype, "setupAsDefault", void 0);
BillingApiPaymentIntentAbstractDto = __decorate([(0, class_transformer_1.Exclude)()], BillingApiPaymentIntentAbstractDto);
exports.BillingApiPaymentIntentAbstractDto = BillingApiPaymentIntentAbstractDto;
let BillingApiPaymentIntentDto = class BillingApiPaymentIntentDto extends BillingApiPaymentIntentAbstractDto {};
__decorate([(0, swagger_1.ApiProperty)({
  description: "Id оплачиваемого начисления (все платежи производятся только через начисления)",
  format: "uuid",
  type: String,
  nullable: true,
  required: false
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsUUID)(4), __metadata("design:type", String)], BillingApiPaymentIntentDto.prototype, "chargeId", void 0);
BillingApiPaymentIntentDto = __decorate([(0, class_transformer_1.Exclude)()], BillingApiPaymentIntentDto);
exports.BillingApiPaymentIntentDto = BillingApiPaymentIntentDto;
